import React from 'react';
import PropTypes from 'prop-types';
import { AuthProvider } from './AuthContext';
import { AppProvider } from './AppContext';
import { NotificationProvider } from './NotificationContext';

export { useAuth } from './AuthContext';
export { useApp } from './AppContext';
export { useNotifications } from './NotificationContext';

export const AppProviders = ({ children }) => {
  return (
    <AuthProvider>
      <AppProvider>
        <NotificationProvider>{children}</NotificationProvider>
      </AppProvider>
    </AuthProvider>
  );
};

AppProviders.propTypes = {
  children: PropTypes.node.isRequired,
};

